import {ApplicationRef, Component, OnInit, ViewChild} from '@angular/core';
import {LiveService} from '../../service/live.service';
import {ActivatedRoute} from '@angular/router';
import {IProduct, IRoom} from '../../model/room.model';
import EkoClient from 'eko-sdk';

@Component({
    selector: 'app-live-dashboard',
    templateUrl: './live-dashboard.component.html',
    styleUrls: ['./live-dashboard.component.scss']
})
export class LiveDashboardComponent implements OnInit {
    liveMode = false;
    roomId: string;
    projectId: string;
    room: IRoom;
    saved = false;
    viewAmount: any;
    selectedProduct: IProduct;
    promotedProduct: IProduct;

    constructor(private liveService: LiveService,
                private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            this.roomId = params.token;
        });
        this.projectId = this.route.snapshot.paramMap.get('id');
    }

    ngOnInit(): void {
        this.loadRoomDetail();
    }

    updateStatus(): void {
        const statusLive = this.liveMode ? 'UNPUBLISHED' : 'LIVE_NOW';
        const request = {
            id: this.roomId,
            status: statusLive
        };
        this.liveService.patchByRoomId(request, this.projectId).subscribe(() => {
            this.liveMode = !this.liveMode;
        });
    }

    save(): void {
        const request = {
            id: this.roomId,
            title: this.room.title,
            thumbnailUrl: this.room.thumbnailUrl
        };
        this.liveService.patchByRoomId(request, this.projectId).subscribe(() => {
            this.saved = true;
        });
    }

    onTitleChange(): void {
        this.saved = false;
    }

    copyStreamUrl(val: string): void {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    loadRoomDetail(): void {
        this.liveService.findByRoomId(this.roomId, this.projectId).subscribe((result) => {
            this.room = result.body;
            this.liveMode = this.room.status === 'LIVE_NOW';
            if (this.room && this.room.promotedProducts.length > 0) {
                const products = this.room.products.filter(productRoom => productRoom.id === this.room.promotedProducts[0]);
                this.promotedProduct = products[0];
                this.selectedProduct = this.promotedProduct;
            }
            const client = new EkoClient({
                apiKey: 'b3bae8593e8ea3641f62d81404091688d10a8be1bd343b24',
            });
            client.registerSession({
                userId: this.room.user,
                displayName: this.room.shopName ? this.room.shopName : this.room.user,
            });
        });
    }

    onProductAdded(products: IProduct[]): void {
        this.liveService.addProducts(this.roomId, this.projectId, products).subscribe();
    }

    onProductRemoved(id: string): void {
        this.liveService.removeProducts(this.roomId, this.projectId, [{id}]).subscribe();
    }

    getViewAmount(viewAmount): void {
        if (viewAmount > 1000) {
            viewAmount = (viewAmount / 1000).toFixed(1) + 'K';
        }
        this.viewAmount = viewAmount;
    }

    onProductSelected(product: IProduct): void {
        this.selectedProduct = product;
    }

    promoteOrDemoteProduct(isPromoted: boolean): void {
        const request = {
            id: this.roomId,
            promotedProducts: isPromoted ? [this.selectedProduct.id] : []
        };
        this.liveService.patchByRoomId(request, this.projectId).subscribe((res) => {
            this.room = res.body;
            if (this.room.promotedProducts && this.room.promotedProducts.length > 0) {
                const products = this.room.products.filter(productRoom => productRoom.id === this.room.promotedProducts[0]);
                this.promotedProduct = products[0];
            } else {
                this.promotedProduct = null;
                this.selectedProduct = null;
            }
        });
    }
}
